import { render, staticRenderFns } from "./FormFieldPhone.vue?vue&type=template&id=3a1d4751&scoped=true"
import script from "./FormFieldPhone.vue?vue&type=script&lang=js"
export * from "./FormFieldPhone.vue?vue&type=script&lang=js"
import style0 from "./FormFieldPhone.vue?vue&type=style&index=0&id=3a1d4751&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_supports-color@7.2.0__css_4ebb8a9bdd1166ae2f68e8a453c2f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d4751",
  null
  
)

export default component.exports